module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.$t('transact.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "widthModal": 800
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item.fecha_inicio)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item.fecha_fin)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.cod_seguimiento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.solicitante_nombres) + " " + _vm._s(items.item.solicitante_primer_apellido) + " " + _vm._s(items.item.solicitante_segundo_apellido))]), _vm._v(" "), _c('td', [(items.item.estado == 'SOLICITADO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'EN_PROCESO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'FINALIZADO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "danger",
            "text-color": "black"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55b03aac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eRegister/tramite/Tramite.vue
// module id = 520
// module chunks = 2